import React, {useState,useEffect} from "react";
import AOS from 'aos';

import Banner from "../Components/Banner";
import Button from "../Components/Button";
import FAQ from "../Components/FAQ/FAQ"
import Testimonial from "../Components/testimonial_slider"
import Chatwithus from "../Components/chatwithus"
import FormModal from "../Components/FormModal";

import google_logo from '../images/liaison/Google-Review-Logo 1.png'
import banner_image from "../images/survey/banner_image.png"
import land_surveys from "../images/survey/land_survey.png"
import topographic_survey from "../images/survey/topographic_survey.png"
import boundary_survey from "../images/survey/boundary_survey.png"
import foundation_marking from "../images/survey/foundation_marking.png"
import volumetric_survey from "../images/survey/volumetric_survey.png"
import as_built_survey from "../images/survey/as-built_survey.png"
import digital_survey from "../images/survey/why_survey.png"
import tailored_survey from "../images/survey/tailored_survey.png"
import cost_effective_icon from "../images/survey/cost-effective.png"
import effortless_icon from "../images/survey/effortles_survey.png"
import satisfaction_icon from "../images/survey/dedicated.png"

function Survey () {

     useEffect(()=>{
            AOS.init({duration:1000});
        }, [])

    const[modalToggle, setModalToggle] = useState(false);
    function toggle () {
            setModalToggle(!modalToggle);
    }

    const service = [
        {
            src:land_surveys,
            alt: "Land Surveys",
            heading:"Land Surveys - ALTA / ACSM",
            content:"Plan your construction project with precise building location and markings",

        },
        {
            src:topographic_survey,
            alt: "Topographic Surveys",
            heading:"Topographic Surveys",
            content:"A Topographic Survey is used by architects and engineers for planning site improvements and developments.",
        },
        {
            src:boundary_survey,
            alt: "Boundary Surveys",
            heading:"Boundary Surveys",
            content:"Synchronise / Match your property dimensions and boundaries  with government records.",
        },
        {
            src:foundation_marking,
            alt: "Foundation Marking",
            heading:"Foundation Marking",
            content:"Precisely mark foundation points and building lines from the design plan.",
        },
        {
            src:volumetric_survey,
            alt: "Volumetric Survey",
            heading:"Volumetric Survey",
            content:"Accurate measurement of earth material moved or filled, using advanced digital terrain modeling for precise data analysis.",
        },
        {
            src:as_built_survey,
            alt: "As-built survey",
            heading:"As-built survey",
            content:"Capture the details of the completed building  and ensure compliance with plans for tax submission ",
        },
        

    ];

    const chooseus = [
        {
            src:tailored_survey,
            alt: "Tailored Surveying",
            heading:"Tailored Surveying for Your Project",
            content:"We provide precise surveying solutions for construction, real estate, land development, and mined-out quantity, ensuring accurate and actionable insights every time.",
        },
        {
            src:cost_effective_icon,
            alt: "Smart, Cost-Effective Surveying",
            heading:"Smart, Cost-Effective Surveying",
            content:"Our digital approach cuts down on site visits, reduces labor costs, and maximizes resources delivering more value for your investment",
        },
        {
            src:effortless_icon,
            alt: "Effortless Survey Data Integration",
            heading:"Effortless Survey Data Integration",
            content:"Our survey outputs are available in multiple formats, seamlessly compatible with CAD, GIS, and project management systems ensuring smooth workflow integration.",
        },
        {
            src:satisfaction_icon,
            alt: "Dedicated to Your Satisfaction",
            heading:"Dedicated to Your Satisfaction",
            content:"We ensure clear communication, transparency, and prompt responsiveness earning your trust at every project stage.",
        },

    ]



    return (
        <>
            <Banner
                img = {banner_image}
                mimg={banner_image}
                alt = {"survey_banner"}
                heading = {"Authorised digital Land and Topographic surveying"}
                subheading={"Latest equipment, 3D view & online service"}
                textposition= {"w-[85%] bottom-5 left-5 lg:w-[609px] lg:bottom-24 lg:left-28"}
                renderButton={() => (
                    <Button name={'Get a Survey Now'} design={"filled"} action={"modal-open"} modalfunction={toggle} />
                )}
            />

            <div className='max-w-[816px] mx-auto my-[40px] lg:my-[100px] px-4 flex flex-col items-center'>
                <h1 className='heading max-w-[716px]' data-aos="fade-up">Accurate Digital Survey by Lands and Lands.</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[35px]' data-aos="fade-up" data-aos-duration="800"/>
                <p className="service-description max-w-[870px] mx-auto" data-aos="fade-up" data-aos-duration="1100">Be it individual houses, large farms or estates, Industry sites or institutional properties, Lands and Lands offers the most accurate, quick and convenient digital survey in just one click. </p>
            </div>

            {/* Services Section */}
            <div className=" py-[30px] px-6 sm:py-[60px]">
                <div className="max-w-7xl mx-auto flex flex-wrap justify-between gap-x-[18px] gap-y-[40px]">
                    {service.map((items)=>{
                    return(
                        <div className="w-[400px] h-[552px] mx-auto bg-grey" data-aos="fade-up">
                            <img src={items.src} alt={items.alt} />

                            <div className="text-center mt-[28px] px-7">
                                <h1 className="font-alibaba text-hblack text-[24px] leading-[42px] font-medium">{items.heading}</h1>
                                <p className="font-alibaba text-font-grey text-[18px] font-normal leading-[24px] mt-[15px]">{items.content}</p>
                            </div>
                        </div>
                    )})}
                </div>
            </div>

            {/* Why should you do Digital Survey */}
            <div id="whychooseus" className="bg-[#F8F6F6] max-w-[1250px] mx-auto my-32" data-aos="fade-up">
                <div className=" flex flex-wrap  gap-y-10 justify-between">
                    <img className="object-cover mx-auto xl:mx-0" src={digital_survey} alt="Digital Survey"/>

                    <div className="w-[530px] m-auto py-8 px-4">
                        <h2 className="font-noto text-[45px] leading-[58px] font-semibold text-hblack" data-aos="fade-up">Why should you do a digital survey ?</h2>
                        <p className="font-alibaba text-font-grey text-[19px] font-normal leading-[28px] mt-8" data-aos="fade-up">Are you buying land or selling it, or are you awaiting a loan against your property or for any statutory purposes? . A land survey document is mandatory. Do the dimensions of your property match with the property records that are with you and the government departments? Or do you have a discrepancy? Authorised Digital Survey is the only solution.</p>
                    </div>

                </div>
            </div>

            {/* Why Choose Us */}

            <div className="bg-[#F8F6F6] px-4 py-[30px] sm:py-[80px]">

                <h1 className="font-noto text-[45px] text-hblack text-center font-bold leading-[58px]" data-aos="fade-up">Why choose Us?</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[35px]' data-aos="fade-up" data-aos-duration="800"/>

                <div className="max-w-7xl mx-auto flex flex-wrap gap-6 justify-between mt-20">
                    {chooseus.map((items)=>{
                    return(
                        <div className="w-[294px] h-[435px] mx-auto bg-white p-6 shadow-md " data-aos="fade-up">
                            <img className="w-[70px]" src={items.src} alt={items.alt} />

                            <div className="mt-[35px]">
                                <h1 className="font-noto text-hblack text-[24px] font-bold leading-[36px]">{items.heading}</h1>
                                <p className="font-alibaba text-[17px] text-font-grey font-normal leading-[26px] mt-7">{items.content}</p>
                            </div>
                        </div>
                    )})}
                </div>
                <div className="w-fit mx-auto mt-[90px]" data-aos="fade-up">
                    <Button 
                    name={"Work with Us"}
                    design={"filled"}
                    action={"modal-open"}
                    modalfunction ={toggle}
                />
                </div> 
            </div>

            <FAQ />

            <Testimonial />

            <a href='https://www.google.com/search?sca_esv=0cc3b5bc5eb43f9c&si=AMgyJEvkVjFQtirYNBhM3ZJIRTaSJ6PxY6y1_6WZHGInbzDnMQrBjsHIRqCxxwTbPxUbJ4RMTn-S7H5ZS_OlrXE3HjAzhGXUfdnaJrezLduvGnb69kqo76JZmUEA-jPkDJw4eW3a1_LH&q=Lands+and+Lands+Reviews&sa=X&ved=2ahUKEwin4ZCY1LmPAxU6R2cHHVIaIpUQ0bkNegQIJhAE&biw=1504&bih=860&dpr=2' target="_blank">
                <div className='flex-col justify-center text-center'>
                    <img className='w-[168px] mx-auto' src={google_logo} alt='Google_logo' data-aos="fade-up"/>
                    <p className='text-[18px] text-[#575857] mt-[10px]'data-aos="fade-up">Check out our Google reviews page <span className='text-[#FF0000]'> here.</span></p>
                </div>
            </a>

            <Chatwithus />

            <FormModal 
                modal={modalToggle}
                active={toggle}
            />

        </>
    )
}


export default Survey;